import { getUserEmail } from '../authProvider/authProvider';

// environmentVariable eg. window._env_.ORDER_GOODS_TO_TASK_ENABLED
// 'true', 'false' or a comma separated list of user emails and/or roles, eg. 'Developer, someone@n1.dk'
export const userAllowedThroughFeatureFlag = (environmentVariable: string, userRole?: string) => {
  if (environmentVariable === 'true') return true;
  if (!environmentVariable || environmentVariable === 'false') return false;

  const allowed = [getUserEmail(), userRole ?? ''].map((value) => value.toLocaleLowerCase());
  return environmentVariable
    .split(',')
    .map((entry) => entry.trim().toLocaleLowerCase())
    .some((entry) => !!entry && allowed.includes(entry));
};
